/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PromotionPricingUpdateDTO interface.
 */
export function instanceOfPromotionPricingUpdateDTO(value) {
    return true;
}
export function PromotionPricingUpdateDTOFromJSON(json) {
    return PromotionPricingUpdateDTOFromJSONTyped(json, false);
}
export function PromotionPricingUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'applyPromotion': json['applyPromotion'] == null ? undefined : json['applyPromotion'],
    };
}
export function PromotionPricingUpdateDTOToJSON(json) {
    return PromotionPricingUpdateDTOToJSONTyped(json, false);
}
export function PromotionPricingUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'applyPromotion': value['applyPromotion'],
    };
}
